






















import { Component, Prop, Vue } from 'vue-property-decorator';

import Icon, { IconEnum } from '@/modules/shared/components/icon.component.vue';
import Assets from '@/constants/assets';


export enum ModalWidth {
    Default = 'modal--default-width',
    Medium = 'modal--medium-width',
}


@Component({
    components: {
        Icon,
    },
})
export default class Modal extends Vue {
    @Prop() private isOpen!: boolean;
    // @Prop({ default: ModalSize.DefaultSize }) private modalSize!: ModalSize;
    @Prop({ default: ModalWidth.Default }) private modalWidth!: ModalWidth;


    private assets = Assets;
    private iconEnum = IconEnum;


    private closeModal() {
        this.$emit('closing-modal');
    }

    private hasSlotContent( slotName: string ) {
        return !!this.$slots[ slotName ];
    }
}
